// 设备模板信息api
import request from '@/utils/request'
export const pageListApi = (data) => {
    return request({
        url: 'CheckinLocations/List',
        method: 'post',
        data
    })
}

export const detailApi = (data) => {
    return request({
        url: 'CheckinLocations/byData',
        method: 'post',
        data
    })
}

export const saveApi = (data) => {
    return request({
        url: 'CheckinLocations/save',
        method: 'post',
        data
    })
}